var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Certificate = function Certificate(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M5 6c-.548 0-1 .452-1 1v10a1 1 0 0 0 1 1h5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V7c0-1.652 1.348-3 3-3h14a3 3 0 0 1 3 3v10.001a3 3 0 0 1-1.5 2.595 1 1 0 1 1-1-1.732 1 1 0 0 0 .5-.865V7a1 1 0 0 0-1-1H5Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 11a4 4 0 0 0-3 6.646V22a1 1 0 0 0 1.6.8l1.4-1.05 1.4 1.05A1 1 0 0 0 18 22v-4.354A4 4 0 0 0 15 11Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm3 3.874a4.01 4.01 0 0 1-2 0V20l.4-.3a1 1 0 0 1 1.2 0l.4.3v-1.126Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M6 8a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H6ZM5 12a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM6 14a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H6Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Certificate;